import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../header.css'; // Optional: for styling
import homeHeaderAds from '../data/homeheaderrotate';
import { greetingandwishesdata } from '../data/greetingandwishesdata';

function Header() {
  const navigate = useNavigate();
  const [dateStr, setDateStr] = useState('');
  const [timeStr, setTimeStr] = useState('');
  const [temperature, setTemperature] = useState('Loading...');
  const [adIndex, setAdIndex] = useState(0);
  const [wishIndex, setWishIndex] = useState(0);

  const isDateInRange = (startDate, endDate) => {
    const now = new Date();
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    const hasValidStart = start instanceof Date && !Number.isNaN(start.getTime());
    const hasValidEnd = end instanceof Date && !Number.isNaN(end.getTime());

    if (hasValidStart && now < start) return false;
    if (hasValidEnd && now > end) return false;
    return true;
  };

  const homepageWishes = (Array.isArray(greetingandwishesdata) ? greetingandwishesdata : [])
    .filter((wish) => Boolean(wish && wish.homepagefeatured) && isDateInRange(wish.displaystartdate, wish.displayenddate))
    .sort((a, b) => {
      const orderA = Number.isFinite(Number(a.homepagefeaturedorder)) ? Number(a.homepagefeaturedorder) : Number.MAX_SAFE_INTEGER;
      const orderB = Number.isFinite(Number(b.homepagefeaturedorder)) ? Number(b.homepagefeaturedorder) : Number.MAX_SAFE_INTEGER;
      return orderA - orderB;
    });

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      setDateStr(now.toLocaleDateString());
      setTimeStr(now.toLocaleTimeString());
    };
    updateDateTime();
    const timer = setInterval(updateDateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    fetch('https://api.open-meteo.com/v1/forecast?latitude=12.87&longitude=74.88&current_weather=true')
      .then(res => res.json())
      .then(data => {
        if (data && data.current_weather && typeof data.current_weather.temperature === 'number') {
          setTemperature(data.current_weather.temperature + '°C');
        } else {
          setTemperature('N/A');
        }
      })
      .catch(() => setTemperature('N/A'));
  }, []);

  useEffect(() => {
    if (!Array.isArray(homeHeaderAds) || homeHeaderAds.length === 0) return;
    const interval = setInterval(() => {
      setAdIndex((prev) => (prev + 1) % homeHeaderAds.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const wishCount = homepageWishes.length;
    if (wishCount === 0) return;
    setWishIndex(0);
    const interval = setInterval(() => {
      setWishIndex((prev) => (prev + 1) % wishCount);
    }, 5000);
    return () => clearInterval(interval);
  }, [homepageWishes.length]);

  const getAdAt = (offset) => {
    if (!Array.isArray(homeHeaderAds) || homeHeaderAds.length === 0) return null;
    return homeHeaderAds[(adIndex + offset) % homeHeaderAds.length];
  };

  const renderAd = (ad) => {
    if (!ad) {
      return (
        <div style={{ width: '105px', height: '65px', background: '#f5f5f5', border: '1px dashed #bbb', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', fontSize: '0.72rem', fontWeight: 500, whiteSpace: 'normal', textAlign: 'center' }}>
          Google Ad
        </div>
      );
    }

    const handleAdClick = () => {
      const selectedId = ad.id || ad.bid || ad.slno;
      if (selectedId) {
        navigate(`/homeheaderrotatelist?highlight=${selectedId}`);
      } else {
        navigate('/homeheaderrotatelist');
      }
      window.scrollTo(0, 0);
    };

    const content = (
      <div style={{ width: '105px', height: '65px', borderRadius: '4px', overflow: 'hidden', border: '1px solid #e0e0e0', position: 'relative' }}>
        <img src={ad.imagepath} alt={ad.businessname || ad.title || 'Advertisement'} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, padding: '2px 6px', background: 'rgba(0,0,0,0.55)', color: '#fff', fontSize: '0.68rem', fontWeight: 600, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
          {ad.title || ad.businessname}
        </div>
      </div>
    );

    return (
      <button
        onClick={handleAdClick}
        aria-label={ad.title || ad.businessname || 'Advertisement'}
        style={{ display: 'inline-block', border: 'none', padding: 0, background: 'transparent', cursor: 'pointer' }}
      >
        {content}
      </button>
    );
  };

  const renderWish = (wish) => {
    if (!wish) return null;

    const handleWishClick = () => {
      navigate(`/greetingandwishes?highlight=${wish.gid}`);
      window.scrollTo(0, 0);
    };

    return (
      <button
        onClick={handleWishClick}
        style={{
          width: '105px',
          height: '65px',
          borderRadius: '4px',
          overflow: 'hidden',
          border: 'none',
          position: 'relative',
          cursor: 'pointer',
          padding: 0,
          background: '#f5f5f5',
          transition: 'transform 0.2s ease'
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.02)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
      >
        <img
          src={wish.imageUrl || wish.imagepath || '/defaultimages/imagenotavailable.jpg'}
          alt={wish.title}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          onError={e => { e.target.src = '/defaultimages/imagenotavailable.jpg'; }}
        />
        <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, padding: '2px 6px', background: 'rgba(0,0,0,0.55)', color: '#fff', fontSize: '0.68rem', fontWeight: 600, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
          {wish.title}
        </div>
      </button>
    );
  };

  return (
    <>
  <div className="header-ad-row" style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginLeft: 0, marginBottom: '.5px' }}>
  <header className="main-header" style={{ flex: 'none', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0, marginLeft: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginLeft: 0 }}>
            <img src="/defaultlogos/mangalorehub_mh_circle.svg" alt="MangaloreHub Logo" style={{ width: '34px', height: '34px', objectFit: 'contain', marginBottom: '0px' }} />
            <h1 style={{ whiteSpace: 'nowrap', margin: 0, marginLeft: 0, marginBottom: '2px' }} tabIndex="0" title="One Stop Services Hub">MangaloreHub.com</h1>
          </div>
          <span style={{ fontSize: '0.82rem', color: '#1976d2', fontWeight: 500, marginLeft: '3rem', marginTop: '-4px', letterSpacing: '0.01em', display: 'block' }}>One stop services hub</span>
          <div style={{ height: '6px', width: '100%' }}></div>
          <div style={{ display: 'flex', gap: '0.25rem', marginTop: '0.5rem', marginLeft: '0', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <div style={{ width: '105px', height: '65px', background: '#f5f5f5', border: '1px dashed #bbb', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', fontSize: '0.7rem', fontWeight: 500, whiteSpace: 'normal', textAlign: 'center' }}>
              Google Ad
            </div>
            {renderAd(getAdAt(0))}
            {renderWish(Array.isArray(homepageWishes) && homepageWishes.length > 0 ? homepageWishes[wishIndex] : null)}
          </div>
        </header>
        
      </div>
      {/* Highlights bar */}
      <div className="highlights-bar">
        <div className="highlights-ticker">
          <span className="highlight-item" style={{ color: '#388e3c', textDecoration: 'none', marginRight: 12, fontWeight: 400 , fontSize: '0.82rem', marginTop: '0px' }}>
            {dateStr} ({new Date().toLocaleDateString('en-US', { weekday: 'long' })}) | {timeStr} | Temp: {temperature}
          </span>
          <Link className="highlight-item" to="/services" style={{ color: '#521edfff', textDecoration: 'none', marginRight: 12, fontSize: '0.82rem' }}>Looking for a Electrician/Plumber/Domestic help in your area?</Link>
          <Link className="highlight-item" to="/classifieds" style={{ color: '#521edfff', textDecoration: 'none', marginRight: 12, fontSize: '0.82rem' }}>New Classifieds Posted</Link>
          <Link className="highlight-item" to="/hotels" style={{ color: '#521edfff', textDecoration: 'none', marginRight: 12, fontSize: '0.82rem' }}>Great Hotels discounts on local stays!</Link>
          <Link className="highlight-item" to="/realestate" style={{ color: '#521edfff', textDecoration: 'none', marginRight: 12, fontSize: '0.82rem' }}>Real Estate Listings Updated</Link>
          <Link className="highlight-item" to="/flyers" style={{ color: '#521edfff', textDecoration: 'none', marginRight: 12, fontSize: '0.82rem' }}>Festive Sales Flyers Available. Great deals on local shops!</Link>
          <Link className="highlight-item" to="/rentals" style={{ color: '#521edfff', textDecoration: 'none', marginRight: 12, fontSize: '0.82rem' }}>Looking for Rent Cars, Generators, Houses?</Link>
          <Link className="highlight-item" to="/services" style={{ color: '#521edfff', textDecoration: 'none', marginRight: 12, fontSize: '0.82rem' }}>Hospitals & Clinics</Link>
          <Link className="highlight-item" to="/buyorsellgeneral" style={{ color: '#521edfff', textDecoration: 'none', marginRight: 12, fontSize: '0.82rem' }}>Buy or Sell your used or new items</Link>
          <Link className="highlight-item" to="/jobs" style={{ color: '#521edfff', textDecoration: 'none', marginRight: 12, fontSize: '0.82rem' }}>Jobs: Hiring Now!</Link>
          <Link className="highlight-item" to="/eventplanning" style={{ color: '#521edfff', textDecoration: 'none', marginRight: 12, fontSize: '0.82rem' }}>Let us take care of everything while you enjoy the moment! 📞 Contact us today to plan your perfect event.</Link>
        </div>
      </div>
      <header>
        <nav className="nav-bar" style={{ fontSize: '0.40rem', fontWeight: 400 }}>
            <Link to="/home">Home</Link>
            <Link to="/services">Services</Link>
            <Link to="/classifieds" className="blink">Classifieds</Link>
            <Link to="/flyers">Flyers</Link>
            <Link to="/rentals">Rentals</Link>
            <Link to="/realestate">Real Estate</Link>
            <Link to="/eventplanning" title="Event Planning">Event Planning</Link>
            <Link to="/buyorsellgeneral">Buy/Sell</Link>
            <Link to="/contact">Contact Us</Link>
        </nav>
      </header>
    </>
  );
}

export default Header;